import { BaseType } from '../../../models/base/base-type';
import { FiduciaryPowerOfAttorneyAppointmentTypeEnum } from '../enums/fiduciary-power-of-attorney-appointment-type.enum';

export class FiduciaryPowerOfAttorneyAppointmentType extends BaseType {
  public declare id: FiduciaryPowerOfAttorneyAppointmentTypeEnum;
}
